import { useQueryClient } from '@tanstack/react-query';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { useCurrentSchoolyearIdSchoolId } from '@teetsh/app/src/queries/schoolyears/atom';
import { Crisp } from 'crisp-sdk-web';
import posthog from 'posthog-js';

export interface LoginRequestPayload {
  email: string;
  password: string;
}

export function logout({
  disableLogoutOtherTabs = false,
}: {
  disableLogoutOtherTabs?: boolean;
} = {}) {
  localStorage.removeItem('id_token');
  localStorage.removeItem('email');
  localStorage.removeItem('twk_token');
  Cookies.remove('tawkUUID', { path: '/', domain: 'va.tawk.to' });
  Cookies.remove('TawkConnectionTime', { path: '/', domain: 'va.tawk.to' });
  if (!disableLogoutOtherTabs) {
    localStorage.setItem('logout-event', Date.now().toString());
  }
  Crisp.session.reset();
  posthog.reset(); // strongly recommend, see https://posthog.com/docs/product-analytics/identify#reset
}

export default function useLogout() {
  const { reset } = useCurrentSchoolyearIdSchoolId();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return ({
    disableLogoutOtherTabs = false,
  }: {
    disableLogoutOtherTabs?: boolean;
  } = {}) => {
    logout({ disableLogoutOtherTabs });
    queryClient.cancelQueries();
    queryClient.clear();
    reset();
    queryClient.invalidateQueries();
    navigate('/login');
    return Promise.resolve().then(() => {
      window.location.reload();
    });
  };
}
